// extracted by mini-css-extract-plugin
export default {"centeredText":"GenericLogin_centeredText__OXK41","form":"GenericLogin_form__qOh1T"};